import React from "react";

//components
import NavBar from "components/navBar";

//style
import "./index.css";

const Terms = (): JSX.Element => {
  return (
    <>
      <NavBar />

      <div className="globe-green-bg"></div>
      <div className="lg:px-36 lg:mx-0 mx-5">
        <div className="terms-card md:p-12 p-5 mb-32">
          <h3 className="text-2xl black-text font-semibold">
            Terms of Service
          </h3>

          <p className="text-sm black-text md:my-10 my-5">
            Lorem sit aliquet rutrum facilisis aliquet eu. Pellentesque elit
            imperdiet ornare bibendum mattis semper tempus urna arcu. Molestie
            nam hendrerit id mattis urna, elit sit. Nec tortor, dis euismod
            felis orci quis pellentesque pulvinar. Donec neque vitae dui, aenean
            semper morbi. Ultrices facilisis porta libero in egestas morbi
            turpis. Quisque pellentesque praesent enim eu diam quisque sagittis
            nibh. Eget dui purus nunc diam. Pretium magna leo tincidunt cras
            pellentesque aliquam. Et a commodo ut eu, lectus nibh vitae donec
            auctor. Et, mi tortor imperdiet molestie odio leo nunc. Fermentum
            nunc cursus justo, bibendum id. Sit orci, aliquam venenatis cursus
            ut. Consectetur dui congue massa, lectus facilisi sit integer. Sed
            et, non etiam sed maecenas. Egestas ut aliquam turpis at. Tempus,
            aliquam vulputate ultricies turpis. In ut amet eu nunc eget. Est
            purus nec tincidunt cursus tellus ac habitant sed condimentum. Cras
            felis eget rutrum natoque turpis varius ac at viverra. Id vel tortor
            ut non magna diam, sed blandit. Euismod turpis mattis suspendisse
            leo eu ultrices lacus. <br />
            Tempus, non velit tellus mattis neque vestibulum sed sagittis sit.
            Semper velit, nunc massa fringilla malesuada eros. Massa praesent
            vulputate vestibulum sed porta massa sollicitudin. Eget morbi hac
            egestas mauris fermentum, consectetur massa. Neque, suspendisse id
            vel sed malesuada. Lectus blandit elit nibh arcu et, venenatis sit.
            Eu nisl vulputate tortor non ultricies suscipit blandit lorem.
            Turpis sem feugiat sollicitudin euismod nunc vitae leo sed. Ut
            dictum consequat blandit velit. Tristique risus nunc, amet, sed
            commodo donec mattis lorem. Elit dignissim lacinia nibh nisl ut
            massa platea. Dictum pulvinar arcu quam mattis elementum congue
            egestas cum viverra. Gravida enim scelerisque risus eu ut fermentum.
            Et sit urna, ac faucibus placerat vestibulum. Cursus consectetur id
            et nibh dolor suspendisse sed consectetur. Adipiscing sit sed
            blandit posuere faucibus. Sed consequat quis vitae pretium
            pellentesque. Ullamcorper dolor arcu massa diam elit eget. Turpis
            lectus ullamcorper aliquam viverra mi. <br /> Adipiscing cras mauris
            velit enim ultricies semper. Tellus scelerisque habitasse mauris
            dictum eget ut laoreet molestie commodo. Nisi sagittis malesuada
            lorem cursus. Dolor quisque scelerisque purus odio amet nisl morbi
            tortor. Sit urna, ipsum sit ornare pharetra, ut. Condimentum eget
            velit interdum gravida. Vel proin arcu ornare mi, consequat orci
            vitae feugiat eu. Sodales lacinia id vivamus vel justo faucibus
            gravida sodales sed. Donec parturient viverra amet, aliquet. Nunc
            nunc proin aliquet consectetur. Tristique mauris odio lobortis at
            iaculis fermentum elementum. In mi quis sed arcu. Rhoncus venenatis
            nulla curabitur at porttitor id pellentesque elit. Convallis
            hendrerit metus nisl lobortis scelerisque. Faucibus vitae in est
            eros, feugiat mi auctor at. Felis vulputate nunc lobortis morbi
            ornare ultrices elementum. Suscipit lectus commodo in est turpis
            arcu, et risus. Eget porta nam pellentesque dapibus adipiscing at
            risus, nullam. Platea integer elementum nibh adipiscing nisl. Ut a
            placerat eros arcu tincidunt feugiat. <br /> Vel duis arcu lobortis
            quam id. In mus aliquet aliquet turpis viverra quisque urna sit
            fames. Leo, nibh adipiscing dictumst sit dictum et egestas at nibh.
            Tortor vitae mauris eget justo nisl felis habitant non. Natoque
            urna, orci pretium, penatibus potenti hac aliquam. At viverra
            consectetur condimentum posuere ut cursus. Id enim in nunc suscipit
            dolor vitae tellus. Pretium, tortor tortor, elit odio nullam
            scelerisque. In purus ornare duis amet. Ultrices sollicitudin
            pretium sit quis etiam morbi orci ullamcorper. Ac eget vitae netus
            id gravida praesent. A, adipiscing gravida gravida nibh. Molestie
            nisl enim mauris odio placerat et. Massa mi est ipsum ut mattis
            viverra volutpat. Lorem sit aliquet rutrum facilisis aliquet eu.
            Pellentesque elit imperdiet ornare bibendum mattis semper tempus
            urna arcu. Molestie nam hendrerit id mattis urna, elit sit. Nec
            tortor, dis euismod felis orci quis pellentesque pulvinar. Donec
            neque vitae dui, aenean semper morbi. Ultrices facilisis porta
            libero in egestas morbi turpis. Quisque pellentesque praesent enim
            eu diam quisque sagittis nibh. Eget dui purus nunc diam. Pretium
            magna leo tincidunt cras pellentesque aliquam. Et a commodo ut eu,
            lectus nibh vitae donec auctor. Et, mi tortor imperdiet molestie
            odio leo nunc. Fermentum nunc cursus justo, bibendum id. Sit orci,
            aliquam venenatis cursus ut. Consectetur dui congue massa, lectus
            facilisi sit integer. Sed et, non etiam sed maecenas. Egestas ut
            aliquam turpis at. Tempus, aliquam vulputate ultricies turpis. In ut
            amet eu nunc eget. Est purus nec tincidunt cursus tellus ac habitant
            sed condimentum. Cras felis eget rutrum natoque turpis varius ac at
            viverra. Id vel tortor ut non magna diam, sed blandit. Euismod
            turpis mattis suspendisse leo eu ultrices lacus. Tempus, non velit
            tellus mattis neque vestibulum sed sagittis sit. Semper velit, nunc
            massa fringilla malesuada eros. Massa praesent vulputate vestibulum
            sed porta massa sollicitudin. Eget morbi hac egestas mauris
            fermentum, consectetur massa. Neque, suspendisse id vel sed
            malesuada. Lectus blandit elit nibh arcu et, venenatis sit. Eu nisl
            vulputate tortor non ultricies suscipit blandit lorem. Turpis sem
            feugiat sollicitudin euismod nunc vitae leo sed. <br /> Ut dictum
            consequat blandit velit. Tristique risus nunc, amet, sed commodo
            donec mattis lorem. Elit dignissim lacinia nibh nisl ut massa
            platea. Dictum pulvinar arcu quam mattis elementum congue egestas
            cum viverra. Gravida enim scelerisque risus eu ut fermentum. Et sit
            urna, ac faucibus placerat vestibulum. Cursus consectetur id et nibh
            dolor suspendisse sed consectetur. Adipiscing sit sed blandit
            posuere faucibus. Sed consequat quis vitae pretium pellentesque.
            Ullamcorper dolor arcu massa diam elit eget. Turpis lectus
            ullamcorper aliquam viverra mi. Adipiscing cras mauris velit enim
            ultricies semper. Tellus scelerisque habitasse mauris dictum eget ut
            laoreet molestie commodo. Nisi sagittis malesuada lorem cursus.
            Dolor quisque scelerisque purus odio amet nisl morbi tortor. Sit
            urna, ipsum sit ornare pharetra, ut. Condimentum eget velit interdum
            gravida. Vel proin arcu ornare mi, consequat orci vitae feugiat eu.
            Sodales lacinia id vivamus vel justo faucibus gravida sodales sed.
            Donec parturient viverra amet, aliquet. Nunc nunc proin aliquet
            consectetur. Tristique mauris odio lobortis at iaculis fermentum
            elementum. In mi quis sed arcu. Rhoncus venenatis nulla curabitur at
            porttitor id pellentesque elit. Convallis hendrerit metus nisl
            lobortis scelerisque. Faucibus vitae in est eros, feugiat mi auctor
            at. Felis vulputate nunc lobortis morbi ornare ultrices elementum.
            Suscipit lectus commodo in est turpis arcu, et risus. Eget porta nam
            pellentesque dapibus adipiscing at risus, nullam. Platea integer
            elementum nibh adipiscing nisl. Ut a placerat eros arcu tincidunt
            feugiat. Vel duis arcu lobortis quam id. In mus aliquet aliquet
            turpis viverra quisque urna sit fames. Leo, nibh adipiscing dictumst
            sit dictum et egestas at nibh. Tortor vitae mauris eget justo nisl
            felis habitant non. Natoque urna, orci pretium, penatibus potenti
            hac aliquam. At viverra consectetur condimentum posuere ut cursus.
            Id enim in nunc suscipit dolor vitae tellus. Pretium, tortor tortor,
            elit odio nullam scelerisque. In purus ornare duis amet. Ultrices
            sollicitudin pretium sit quis etiam morbi orci ullamcorper. Ac eget
            vitae netus id gravida praesent. A, adipiscing gravida gravida nibh.
            Molestie nisl enim mauris odio placerat et. Massa mi est ipsum ut
            mattis viverra volutpat.
          </p>
        </div>
      </div>
    </>
  );
};

export default Terms;
